import api from "./axios"

export const messageApi = {

  // SEND MESSAGE REQUEST
  sendMessageRequest: async (userId, message) => {
    const res = await api.post(`/message-requests/${userId}`, {
      message,
    });
    return res.data;
  },


};

